import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type UpdateUserSettingsMutationVariables = Types.Exact<{
	jwConsents?: Types.InputMaybe<Types.JwConsentsInput>;
	ucConsents?: Types.InputMaybe<Array<Types.UcConsentsInput> | Types.UcConsentsInput>;
	addPackageShortNames?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
	removePackageShortNames?: Types.InputMaybe<
		Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
	>;
	country: Types.Scalars['Country']['input'];
	platform?: Types.Platform;
}>;

export type UpdateUserSettingsMutation = {
	__typename?: 'Mutation';
	updateSettings: { __typename: 'UpdateSettingsPayload' };
	addPackages: { __typename?: 'UpdateSettingsPayload'; settings: { __typename: 'Settings' } };
	removePackages: { __typename?: 'UpdateSettingsPayload'; settings: { __typename: 'Settings' } };
};

export const UpdateUserSettingsDocument = gql`
	mutation UpdateUserSettings(
		$jwConsents: JWConsentsInput
		$ucConsents: [UCConsentsInput!]
		$addPackageShortNames: [String!]
		$removePackageShortNames: [String!]
		$country: Country!
		$platform: Platform! = WEB
	) {
		updateSettings(input: { jwConsents: $jwConsents, ucConsents: $ucConsents }) {
			__typename
		}
		addPackages: setPackage(
			input: { packages: $addPackageShortNames, country: $country, platform: $platform, state: true }
		) {
			settings {
				__typename
			}
		}
		removePackages: setPackage(
			input: { packages: $removePackageShortNames, country: $country, platform: $platform, state: false }
		) {
			settings {
				__typename
			}
		}
	}
`;
